/** Премия по сделке — ровно то, что отдаёт `GET /api/deals/{id}/bonus`. */
import { apiFetch } from "@/lib/api";

/** Проводка биллинга CRM: начисление (+) или списание (−). */
export type BonusBilling = {
  id: number;
  at: string;
  amount: number;
  module: string;
  user: string | null;
};

/** Строка `sUser_bonus_deal`: расчёт премии по товару. */
export type BonusRow = {
  id: number;
  user: string | null;
  second_user: string | null;
  price_account: number;
  price_cost: number | null;
  price: number;
  percent: number;
  percent_type: string;
  bonus_sum: number;
  archive: string;
  archived: boolean;
  date_operation: string | null;
  date_deactivate: string | null;
  changes: string[];
  billing: BonusBilling[];
  net: number;
  not_accrued: string[];
};

/** Журнал балансом: проводки по времени, остаток нарастающим итогом. */
export type BonusLedger = {
  items: (BonusBilling & { balance: number; note: string | null })[];
  accrued: number;
  written_off: number;
  net: number;
};

export type BonusPart = "product" | "second" | "payment" | "refuse" | "mentor" | "other";

export type DealBonus = {
  deal_id: number;
  total: { net: number; accrued: number; written_off: number; pending: number };
  by_user: { user_id: number; name: string | null; net: number; parts: Record<BonusPart, number> }[];
  products: {
    serial: number;
    name: string | null;
    image: string | null;
    is_sale: boolean;
    deleted: boolean;
    active: BonusRow | null;
    history: BonusRow[];
    ledger: BonusLedger;
  }[];
  other: BonusLedger;
  deal: { stage: string; paid: number; product_sum: number } | null;
};

export function loadDealBonus(id: number): Promise<DealBonus> {
  return apiFetch<DealBonus>(`/api/deals/${id}/bonus`);
}
